/* eslint-disable no-async-promise-executor */
let firebasePromise = null

async function getFirebase() {
  if (!firebasePromise) {
    firebasePromise = (async () => {
      const { default: firebase } = await import('firebase/app')
      await Promise.all([
        import('firebase/database'),
        import('firebase/messaging'),
        import('firebase/auth'),
      ])
      if (!firebase.apps.length) {
        const Project = (await import('project.config')).default
        firebase.initializeApp(Project.firebaseConfig)
      }
      return firebase
    })()
  }
  return firebasePromise
}

export async function logoutFirebase() {
  const firebase = await getFirebase()
  firebase.auth().signOut()
}

export async function getFirebaseToken() {
  const firebase = await getFirebase()
  return new Promise(async (resolve, reject) => {
    try {
      if (firebase.messaging.isSupported()) {
        const permission = await Notification.requestPermission()
        if (permission === 'granted') {
          const token = await firebase.messaging().getToken()
          if (token) {
            return resolve(token)
          }
        }
      }
      reject()
    } catch (error) {
      reject(error)
    }
  })
}

// Helper to get instances asynchronously
async function getDb() {
  const firebase = await getFirebase()
  return firebase.database()
}

async function getAuth() {
  const firebase = await getFirebase()
  return firebase.auth()
}

async function getServerTimestamp() {
  const firebase = await getFirebase()
  return firebase.database.ServerValue.TIMESTAMP
}

export const firebaseService = {
  logoutFirebase,
  getFirebase,
  getFirebaseToken,
  getDb,
  getAuth,
  getServerTimestamp,
}
